import { useEffect } from 'react';

const upsertMetaTag = (attribute, key, value) => {
  if (!value) return;
  let tag = document.head.querySelector(`meta[${attribute}="${key}"]`);
  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute(attribute, key);
    document.head.appendChild(tag);
  }
  tag.setAttribute('content', value);
};

const upsertLinkTag = (rel, href) => {
  if (!href) return;
  let link = document.head.querySelector(`link[rel="${rel}"]`);
  if (!link) {
    link = document.createElement('link');
    link.setAttribute('rel', rel);
    document.head.appendChild(link);
  }
  link.setAttribute('href', href);
};

const resolveUrl = (value, baseUrl) => {
  if (!value) return '';
  try {
    return new URL(value, baseUrl).toString();
  } catch (_error) {
    return value;
  }
};

const clone = (object) => JSON.parse(JSON.stringify(object));

const SEO = ({
  title,
  description,
  path = '/',
  image = '/praxis.jpeg',
  type = 'website',
  locale = 'de_DE',
  structuredData,
  keywords = [],
  siteName = 'Privatpraxis für Psychiatrie und Psychotherapie Maliha Malik',
}) => {
  useEffect(() => {
    const baseUrl =
      process.env.REACT_APP_SITE_URL ||
      (typeof window !== 'undefined' ? window.location.origin : '');

    const canonicalUrl = resolveUrl(path, baseUrl);
    const imageUrl = resolveUrl(image, baseUrl);

    if (title) {
      document.title = title;
    }

    upsertMetaTag('name', 'description', description);
    if (keywords.length > 0) {
      upsertMetaTag('name', 'keywords', keywords.join(', '));
    }
    upsertMetaTag('name', 'robots', 'index, follow');
    upsertMetaTag('name', 'author', 'Maliha Malik');
    upsertMetaTag('property', 'og:title', title);
    upsertMetaTag('property', 'og:description', description);
    upsertMetaTag('property', 'og:type', type);
    upsertMetaTag('property', 'og:locale', locale);
    upsertMetaTag('property', 'og:url', canonicalUrl);
    upsertMetaTag('property', 'og:site_name', siteName);
    upsertMetaTag('property', 'og:image', imageUrl);
    upsertMetaTag('name', 'twitter:card', 'summary_large_image');
    upsertMetaTag('name', 'twitter:title', title);
    upsertMetaTag('name', 'twitter:description', description);
    upsertMetaTag('name', 'twitter:image', imageUrl);
    upsertLinkTag('canonical', canonicalUrl);

    const jsonLd = structuredData
      ? (() => {
          const data = clone(structuredData);
          if (!data.url) {
            data.url = canonicalUrl;
          }
          if (data.image) {
            data.image = Array.isArray(data.image)
              ? data.image.map((entry) => resolveUrl(entry, baseUrl))
              : resolveUrl(data.image, baseUrl);
          } else {
            data.image = imageUrl;
          }
          return data;
        })()
      : null;

    const scriptId = 'structured-data';
    let scriptTag = document.head.querySelector(`#${scriptId}`);

    if (jsonLd) {
      if (!scriptTag) {
        scriptTag = document.createElement('script');
        scriptTag.setAttribute('type', 'application/ld+json');
        scriptTag.setAttribute('id', scriptId);
        document.head.appendChild(scriptTag);
      }
      scriptTag.textContent = JSON.stringify(jsonLd);
    } else if (scriptTag) {
      scriptTag.remove();
    }
  }, [
    description,
    image,
    keywords,
    locale,
    path,
    structuredData,
    title,
    type,
    siteName,
  ]);

  return null;
};

export default SEO;
